import React from 'react';
import { createRoot } from 'react-dom/client';
import { EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { DecouplerProvider } from 'react-decoupler';
import config from 'devextreme/core/config';
import serviceLocator from './configure-services';
import SERVICE_KEYS from './services/service-keys';
import { licenseKey } from './devextreme-license';
import './devextreme-editors';
import App from './app';
import '@fortawesome/fontawesome-free/css/solid.min.css';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import './index.css';

config({ licenseKey });

(async () => {
  const pca = serviceLocator.resolve([SERVICE_KEYS.AUTH])[0].getPublicClientApplicationInstance();
  await pca.initialize();

  pca.addEventCallback((message) => {
    if (message.eventType === EventType.ACCOUNT_ADDED) {
      const account = message.payload;
      pca.setActiveAccount(account);
    } else if (message.eventType === EventType.ACCOUNT_REMOVED) {
      pca.setActiveAccount(null);
    }
  });

  const root = createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={pca}>
        <DecouplerProvider locator={serviceLocator}>
          <App />
        </DecouplerProvider>
      </MsalProvider>
    </React.StrictMode>
  );
})();
